module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dof-music-player weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "play-top weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm._theme !== 'colmo') ? _c('figure', {
    staticClass: "top-img weex-el weex-image",
    attrs: {
      "src": _vm.moveImg,
      "data-img-src": _vm.moveImg,
      "weex-type": "image"
    }
  }) : (_vm._theme == 'colmo') ? _c('dof-iconfont', {
    attrs: {
      "code": '\u4790',
      "size": "50",
      "color": "rgba(255,255,255,0.8)"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "topTitle",
    staticClass: "top-title weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.marqueeShowFlag) ? _c('dof-marquee', {
    attrs: {
      "width": _vm.marqueeWidth,
      "textWidth": _vm.marqueeTextWidth,
      "height": "44px",
      "text": _vm.marqueeText,
      "bgColor": _vm.themeStyle.marqueeBgColor,
      "textColor": _vm.themeStyle.marqueeTextColor,
      "duration": 10000,
      "delay": 3000
    }
  }) : _c('p', {
    staticClass: "top-title-text weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.playText) + ": " + _vm._s(_vm.title))])], 1), _vm._v(" "), (_vm._theme !== 'colmo') ? _c('div', {
    staticClass: "top-right weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.play) ? _c('figure', {
    staticClass: "top-img top-img-play weex-el weex-image",
    attrs: {
      "src": _vm.playImg,
      "data-img-src": _vm.playImg,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.playHandler('pause')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.play) ? _c('figure', {
    staticClass: "top-img top-img-play weex-el weex-image",
    attrs: {
      "src": _vm.pauseImg,
      "data-img-src": _vm.pauseImg,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.playHandler('play')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('figure', {
    staticClass: "top-img weex-el weex-image",
    attrs: {
      "src": _vm.nextImg,
      "data-img-src": _vm.nextImg,
      "weex-type": "image",
      "data-evt-click": ""
    },
    on: {
      "click": _vm.$stopOuterA,
      "weex$tap": function($event) {
        $event.stopPropagation();
        return _vm.nextHandler($event)
      }
    }
  })]) : (_vm._theme == 'colmo') ? _c('div', {
    staticClass: "top-right weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.play) ? _c('dof-iconfont', {
    staticClass: "top-img-play",
    attrs: {
      "code": '\u4773',
      "size": "50",
      "color": "rgba(255,255,255,0.8)",
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": function($event) {
        return _vm.playHandler('pause')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.play) ? _c('dof-iconfont', {
    staticClass: "top-img-play",
    attrs: {
      "code": '\u4770',
      "color": "rgba(255,255,255,0.8)",
      "size": "50",
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": function($event) {
        return _vm.playHandler('play')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('dof-iconfont', {
    attrs: {
      "code": '\u4765',
      "size": "50",
      "color": "rgba(255,255,255,0.8)",
      "data-evt-dofIconFontClicked": ""
    },
    on: {
      "dofIconFontClicked": _vm.nextHandler
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('p', {
    ref: "titleLen",
    staticClass: "top-title-text title-hidden weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.playText) + ": " + _vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "volume-content weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm._theme !== 'colmo') ? _c('figure', {
    staticClass: "top-img volume-img volume-img-left weex-el weex-image",
    attrs: {
      "src": _vm.volumeLowImg,
      "data-img-src": _vm.volumeLowImg,
      "weex-type": "image"
    }
  }) : (_vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: "volume-img volume-img-left",
    attrs: {
      "code": '\u4763',
      "size": "64",
      "color": "rgba(255,255,255,0.8)"
    }
  }) : _vm._e(), _vm._v(" "), _c('dof-slider', {
    attrs: {
      "min": _vm.min,
      "max": _vm.max,
      "theme": _vm.theme,
      "track-height": _vm._trackHeight,
      "track-color": _vm.trackColor,
      "bar-color": _vm.barColor,
      "button-size": _vm._buttonSize,
      "button-color": _vm.buttonColor,
      "readonly": _vm.readonly,
      "step": _vm.step,
      "gradientBarConfig": _vm._gradientBarConfig,
      "data-evt-change": ""
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.sliderChangeHandler($event)
      }
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  }), _vm._v(" "), (_vm._theme !== 'colmo') ? _c('figure', {
    staticClass: "top-img volume-img volume-img-right weex-el weex-image",
    attrs: {
      "src": _vm.volumeHighImg,
      "data-img-src": _vm.volumeHighImg,
      "weex-type": "image"
    }
  }) : (_vm._theme == 'colmo') ? _c('dof-iconfont', {
    staticClass: "volume-img volume-img-right",
    attrs: {
      "code": '\u4791',
      "size": "64",
      "color": "rgba(255,255,255,0.8)"
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b720a78", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b720a78","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-music-player/index.vue
// module id = 593
// module chunks = 0 1